import { createContext } from "react"
import React from "react"
import { EstabelecimentosAplicativoInicial } from "../models/estabelecimentosAplicativoModel"
import type { EstabelecimentosAplicativoModel } from "../models/estabelecimentosAplicativoModel"
import type { EstabelecimentosAplicativoActionModel } from "./estabelecimentosAplicativoActions"

type EstabelecimentosAplicativoContextProps = {
    dados: EstabelecimentosAplicativoModel
    dispatch: React.Dispatch<EstabelecimentosAplicativoActionModel>
    adicionar: (idEstabelecimento: number) => Promise<void>
    desassociar: (idEstabelecimento: number) => Promise<void>
    erroCarregamento: string | null
}

const initialContextValue: EstabelecimentosAplicativoContextProps = {
    dados: EstabelecimentosAplicativoInicial,
    dispatch: () => {},
    adicionar: async () => {},
    desassociar: async () => {},
    erroCarregamento: null,
}

export const EstabelecimentosAplicativoContext =
    createContext<EstabelecimentosAplicativoContextProps>(initialContextValue)
